module.exports = __webpack_public_path__ + "img/运营优势.14c4e3dd.png";